



























































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from "vue-property-decorator";


//@ts-ignore
import TablePPoa from "@/components/tables/tablev1";
//@ts-ignore
import { email, required } from "vuelidate/lib/validators";
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'
import OrganizationChart from "vue-organization-chart";
import "vue-organization-chart/dist/orgchart.css";
import VueHtml2pdf from "vue-html2pdf";
import bootstrap from "!raw-loader!./bootstrap.css";
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'
import VueAxios from "vue-axios";
import axios from "axios";

//@ts-ignore
import pdf from '@/mixins/axios/pdf'
import { Bar } from 'vue-chartjs'

//@ts-ignore
import reportes from '@/mixins/axios/reportes'
//@ts-ignore
import poa_series from '@/mixins/axios/poa_series'


//@ts-ignore
@Component({
  components: {OrganizationChart,'bar':Bar},

  data() {
    return {
     color:'#005aff',
      color1:'#1332a0',
      color2:'#1f7ad8',
      color3:'#0013ff',
      keyvalue:1,
       options: {
      responsive: true,
      maintainAspectRatio: false
    },
    series:[],
    serie:0,
 htmltecho:'',
 trimestre:0,
 datacollection:{},
 parsedata:[],
 parselabels:[],
 type:'all',
 indexg:0,
 ind_sec:0,
 ind_dep:0,
 ind_lin:0,
 ind_poa:0,
 myChart:null,
 data:[{"nombre":"Secre Chida","id":5,"fisico_e":[19,6,6,3],"fisico_a":[1,12,1,8],"departamentos":[{"nombre":"Chido","id":3,"fisico_e":[19,6,6,3],"fisico_a":[1,12,1,8],"poas":[{"nombre":"Poa aaa","id":1,"fisico_e":[19,6,6,3],"fisico_a":[1,12,1,8],"financiero_e":[0,0,0,0],"financiero_a":[0,0,0,0],"lineas":[{"nombre":"Linea Chida","id":1,"fisico_e":[3,2,1,0],"fisico_a":[1,0,0,0],"actividades":[{"nombre":"zdfxgvhbj","fisico_e":[1,1,0,0],"fisico_a":[0,0,0,0]},{"nombre":"ACTIVIDAD 1","fisico_e":[1,0,0,0],"fisico_a":[1,0,0,0]},{"nombre":"ACTIVIDAD 3","fisico_e":[1,1,1,0],"fisico_a":[0,0,0,0]}]},{"nombre":"Linea 1","id":25,"fisico_e":[6,3,2,3],"fisico_a":[0,2,1,2],"actividades":[{"nombre":"Actividad 5","fisico_e":[1,0,1,0],"fisico_a":[0,1,0,1]},{"nombre":"Actividad 7","fisico_e":[1,0,1,3],"fisico_a":[0,1,0,0]},{"nombre":"Actividad 8","fisico_e":[4,3,0,0],"fisico_a":[0,0,1,1]}]},{"nombre":"Linea 2","id":26,"fisico_e":[10,1,3,0],"fisico_a":[0,10,0,6],"actividades":[{"nombre":"Actividad 10","fisico_e":[4,0,3,0],"fisico_a":[0,4,0,3]},{"nombre":"Actividad 15","fisico_e":[5,0,0,0],"fisico_a":[0,0,0,3]},{"nombre":"Actividad 9","fisico_e":[1,1,0,0],"fisico_a":[0,6,0,0]}]}]},{"nombre":"poa prueba","id":11,"fisico_e":[0,0,0,0],"fisico_a":[0,0,0,0],"financiero_e":[0,0,0,0],"financiero_a":[0,0,0,0]}]},{"nombre":"asdasd","id":5,"fisico_e":[0,0,0,0],"fisico_a":[0,0,0,0]},{"nombre":"depa 2","id":6,"fisico_e":[0,0,0,0],"fisico_a":[0,0,0,0]},{"nombre":"depa 3","id":7,"fisico_e":[0,0,0,0],"fisico_a":[0,0,0,0]}]},{"nombre":"La mas cool","id":6,"fisico_e":[0,0,0,0],"fisico_a":[0,0,0,0],"departamentos":[{"nombre":"el depa cool","id":4,"fisico_e":[0,0,0,0],"fisico_a":[0,0,0,0]}]},{"nombre":"DIF TORREON","id":7,"fisico_e":[0,0,0,0],"fisico_a":[0,0,0,0],"departamentos":[{"nombre":"DIRECCI\u00d3N GENERAL DIF TORRE\u00d3N","id":8,"fisico_e":[0,0,0,0],"fisico_a":[0,0,0,0]}]},{"nombre":"INSTITUTO MUNICIPAL DE LA MUJER","id":8,"fisico_e":[0,0,0,0],"fisico_a":[0,0,0,0],"departamentos":[{"nombre":"DIRECCI\u00d3N DE AGENDA DE G\u00c9NERO","id":9,"fisico_e":[0,0,0,0],"fisico_a":[0,0,0,0]},{"nombre":"DIRECCI\u00d3N DE ATENCI\u00d3N A LAS MUJERES","id":10,"fisico_e":[0,0,0,0],"fisico_a":[0,0,0,0]},{"nombre":"DIRECCI\u00d3N DE CAPACITACI\u00d3N Y ACTIVIDADES PRODUCTIVAS","id":11,"fisico_e":[0,0,0,0],"fisico_a":[0,0,0,0]}]},{"nombre":"CAPITAL HUMANO","id":9,"fisico_e":[4,2,1,1],"fisico_a":[5,5,5,5],"departamentos":[{"nombre":"RECURSOS HUMANOS","id":12,"fisico_e":[4,2,1,1],"fisico_a":[5,5,5,5],"poas":[{"nombre":"SEGURIDAD PUBLICA TORREON","id":12,"fisico_e":[4,2,1,1],"fisico_a":[5,5,5,5],"financiero_e":[0,0,0,0],"financiero_a":[0,0,0,0],"lineas":[{"nombre":"Incidencia delictiva","id":27,"fisico_e":[4,2,1,1],"fisico_a":[5,5,5,5],"actividades":[{"nombre":"AUMENTO DE CUERPO MILITAR","fisico_e":[4,2,1,1],"fisico_a":[5,5,5,5]}]},{"nombre":"Insuficientes elementos operativos de policia","id":28,"fisico_e":[0,0,0,0],"fisico_a":[0,0,0,0]},{"nombre":"Descomposici\u00f3n del tejido social","id":29,"fisico_e":[0,0,0,0],"fisico_a":[0,0,0,0]}]}]}]}]
    };
  },
  mixins: [
 pdf,reportes,poa_series
  ],
  methods: {

 onChangeP(event){



switch (this.type) {
  case 'all':
  
  
    this.parseData(this.data);
   
    break;
    case 'secretaria':
      this.parseData(this.data[this.ind_sec]['departamentos']);
       
    break;
    case 'departamento':
     this.parseData(this.data[this.ind_sec]['departamentos'][this.ind_dep]['poas']);
     
    break;
    case 'poa':
     this.parseData(this.data[this.ind_sec]['departamentos'][this.ind_dep]['poas'][this.ind_poa]['lineas']);
      
    break;
     case 'linea':
     this.parseData(this.data[this.ind_sec]['departamentos'][this.ind_dep]['poas'][this.ind_poa]['lineas'][this.ind_lin]['actividades']);
      
    break;
   
   

  default:
    break;
}


},
    returnMethod(){

switch (this.type) {
  case 'secretaria':
   this.type='all';
  
    this.parseData(this.data);
   
    break;
    case 'departamento':
     this.type='secretaria';
          this.indexg=this.ind_sec;
      this.parseData(this.data[this.ind_sec]['departamentos']);
       
    break;
    case 'poa':
      this.type='departamento';
        this.indexg=this.ind_dep;
     this.parseData(this.data[this.ind_sec]['departamentos'][this.ind_dep]['poas']);
     
    break;
    case 'linea':
     this.type='poa';
        this.indexg=this.ind_poa;
     this.parseData(this.data[this.ind_sec]['departamentos'][this.ind_dep]['poas'][this.ind_poa]['lineas']);
      
    break;
     case 'actividad':
     this.type='linea';
        this.indexg=this.ind_lin;
     this.parseData(this.data[this.ind_sec]['departamentos'][this.ind_dep]['poas'][this.ind_poa]['lineas'][this.ind_lin]['actividades']);
      
    break;
   

  default:
    break;
}



      
    },
  
setData(type,ind1=0,ind2=0,ind3=0,ind4=0,ind5=0){

switch (type) {
  case 'secretaria':
   this.type='secretaria';
   this.ind_sec=ind1;
    this.indexg=ind1;
    this.parseData(this.data[ind1]['departamentos']);
   
    break;
    case 'departamento':
     this.type='departamento';
      this.ind_dep=ind2;
          this.indexg=ind2;
      this.parseData(this.data[ind1]['departamentos'][ind2]['poas']);
       
    break;
    case 'poa':
      this.type='poa';
       this.ind_poa=ind3;
         this.indexg=ind3;
     this.parseData(this.data[ind1]['departamentos'][ind2]['poas'][ind3]['lineas']);
     
    break;
    case 'linea':
     this.type='linea';
      this.ind_lin=ind4;
         this.indexg=ind4;
     this.parseData(this.data[ind1]['departamentos'][ind2]['poas'][ind3]['lineas'][ind4]['actividades']);
      
    break;
   
 
  default:
    break;
}


},
   getRandomColor() {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
},
randColor(){
return 'rgba('+this.randomNumber(20,80)+','+this.randomNumber(0,120)+','+this.randomNumber(50,250)+',1)';
},
 randomNumber(min,max) {
  return Math.random() * (max - min) + min;
},
 onChangeSerie(event){
   this.getData();
 },
fillData(data){
        this.datacollection = {
          labels: ['Trimestre #'+(this.trimestre+1)],
          datasets: this.formatData(data)
        }
       return this.datacollection;
        //this.renderChart(this.datacollection, this.options)
      },
      formatData(data){
        var data_col=[];
        console.log(data)
         let th=this;
        data.forEach((val, index) =>{
         
        
         data_col.push({
              label: val.nombre,
              backgroundColor: th.randColor(),
              data: [(val.fisico_a[th.trimestre]/val.fisico_e[th.trimestre])*100]
            })
        });
          
          
          
        return data_col;

      },

async getSeries(){
  console.log('series')
   this.$root.$emit('loading', true);



let data= await this.GET_POA_SERIES_FILTER().then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.series=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},

      parseData(data){


var ctx = document.getElementById("myChart").getContext('2d');
if(this.myChart!=null){
  this.myChart.destroy();
  this.myChart=null;
}
 this.myChart = new Chart(ctx, {
  type: 'bar',
  data:  this.fillData(data),
  options: {
    indexAxis: 'y',
  
    elements: {
      bar: {
        borderWidth: 2,
      }
    },
    responsive: true,
    plugins: {
      legend: {
        position: 'right',
      },
      title: {
        display: true,
        text: 'Avance Fisico Trimestre #'+(this.trimestre+1)
      }
    },
  
    onClick: function (point, event) {
    	const item = event

      console.log( point)
    	
    }
  },


    
    onClick:function(e){
      console.log(e)
    var activePoints = myChart.getElementsAtEvent(e);
    var selectedIndex = activePoints[0]._index; 
    console.log(selectedIndex,'------t------')
  
    }
});
      },
      PrintImage() {
   
    
     var link = document.createElement('a');
  link.download = 'filename.png';
  link.href = document.getElementById('myChart').toDataURL()
  link.click();

},  
async getData(){
//
 this.show=false;
this.$root.$emit('loading', true);

if(this.serie==0){
 this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar datos, Es necesario seleccionar almenos una serie");

}



let row={
  serie:this.serie,
  secretaria:0,
  programa:0

}
let data= await this.getReporteTrimestre(row).then(response => {

                    if (response != null) {
                
                      this.data=response;
                    this.parseData(this.data);
  
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar datos, refresque la pagina");

                    }
                      this.$root.$emit('loading', false);
                });
},

    

  },
  created() {},
  mounted() {




this.getSeries();


 

/*
document.getElementById("myChart").onclick = function (evt) {
        var activePoints = myChart.getElementsAtEventForMode(evt, 'point', myChart.options);
        var firstPoint = activePoints[0];
        var label = myChart.data.labels[firstPoint._index];
        var value = myChart.data.datasets[firstPoint._datasetIndex].data[firstPoint._index];
        alert(label + ": " + value);
    };
*/

  //this.getData();
  },
})
export default class Home extends Vue {

  // @Prop() private id !:any;
}
